import useApiMutation from '_api/mutations/useApiMutation';
import { EncounterReport, EncounterReportPayload } from '_api/types';

const CREATE_REPORT_KEY = 'create-report-key';
export const useCreateReport = () => {
  return useApiMutation<EncounterReport, EncounterReportPayload>(
    () => `/report/create`,
    'post',
    {},
    {
      mutationKey: [CREATE_REPORT_KEY],
      onSuccess: () => {},
    },
    (body: EncounterReportPayload) => JSON.stringify(body),
  );
};
